/**
 * SGKE361A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface WorkResultArea {

    /**
     * 供給停止再開結果区分コード
     */
    supplystopresumptionResultDivcd?: string;
    /**
     * 供給再開日付
     */
    supplyresumptionDate?: string;
    /**
     * 供給再開時刻
     */
    supplyresumptionHms?: string;
    /**
     * 変更前供給再開予定日
     */
    bfSupplyresumptionPlndate?: string;
    /**
     * 変更後供給再開予定日
     */
    afSupplyresumptionPlndate?: string;
    /**
     * 変更後供給再開予定時間帯
     */
    afSupplyresumptionYtitimez?: string;
    /**
     * 登録日付
     */
    regDate?: string;
}

